import {Component, inject, OnInit, signal} from '@angular/core';
import {DecimalPipe, NgForOf, NgIf} from '@angular/common';
import {GtNgDatepickerModule} from '../../shared/gt-ng-datepicker/gt-ng-datepicker.module';
import {NgbPagination} from '@ng-bootstrap/ng-bootstrap';
import {NotFoundComponent} from '../../shared/not-found/not-found.component';
import {AsyncLoadingComponent} from '../../shared/async-loading/async-loading.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  CertificateDto,
  CommentationDto,
  CommentationSearchParams,
  ManufacturerDto,
  Page
} from '../../../generated-model/model';
import {CommentationRest} from '../../service/CommentationRest';
import {IgnoreNullHttpParams} from '../../shared/Ignore-null-http-params';
import {SharedCommonModule} from '../../shared/shared-common.module';
import {saveAs} from 'file-saver';
import {
  ManufacturerAutocompleteComponent
} from '../../shared/components/manufacturer-autocomplete/manufacturer-autocomplete.component';

@Component({
  selector: 'app-feedback-report',
  standalone: true,
  imports: [
    DecimalPipe,
    GtNgDatepickerModule,
    NgForOf,
    NgIf,
    NgbPagination,
    AsyncLoadingComponent,
    NotFoundComponent,
    ReactiveFormsModule,
    FormsModule,
    SharedCommonModule,
    ManufacturerAutocompleteComponent
  ],
  templateUrl: './feedback-report.component.html',
  styleUrl: './feedback-report.component.scss'
})
export class FeedbackReportComponent implements OnInit {
  pageData:Page<CommentationDto> = {number:1,size:10}
  isLoading = false;
  params:CommentationSearchParams ={rate:null}
  commentationService = inject(CommentationRest)
  manufacturerSelected=signal<ManufacturerDto>(undefined);

  ngOnInit() {
    this.search()
  }

  search(number=1){
    this.isLoading = true;
    this.params.businessName = this.manufacturerSelected()?.businessName
    const pageRequest = {page:number - 1, size:this.pageData.size, sort:'createdDate,desc'}
    let param = IgnoreNullHttpParams.fromObject({...this.params})
      .set('page',pageRequest.page)
      .set('size' , this.pageData.size)
      .set('sort',pageRequest.sort)
    this.commentationService.search(param).subscribe({
      next:data=>{
        this.pageData = data
      }, error:(e)=>{
        console.log(e)
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  export(type:string){
    let param = IgnoreNullHttpParams.fromObject({...this.params})
    param.set('fileType',type)
    this.commentationService.export(param).subscribe({
      next: data => {
        saveAs(new Blob([data], {type: type === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
          `รายงานแบบสอบถามความพึงพอใจ.${type}`);      },error(e){
        console.log(e)
      }
    })
  }

  clear(){
    this.params ={rate: null}
    this.manufacturerSelected.set(undefined)
    this.search()
  }
}
